console.log('app.js loaded');
import $ from './utility/jqueryWrapper.js';
import axios from 'axios';

import jqueryui from 'jquery-ui-dist/jquery-ui.js';

import cookie from 'js-cookie';
import moment from "moment";
import { extendMoment } from 'moment-range';
import storage from 'local-storage-to-object';

import flatpickr from './libs/flatpickr/dist/flatpickr.js'
import ru from './libs/flatpickr/dist/l10n/ru.js'
import './libs/flatpickr/dist/themes/material_pride.css'
// import 'awesome-notifications'

import modal from "micromodal";
import _ from "lodash";
import {drawCoachModal, getServiceIdFromUrl} from "./schedule.helper.js";


window._ = _
window.storage = storage;
window.moment = extendMoment(moment);
window.axios = axios;
window.cookie = cookie;

import 'inputmask/dist/jquery.inputmask.bundle.js';

export function isViewonly(){
    return window.location.search.includes('viewonly');
}

export function initApp(){
    window.person = window.person === undefined ? {} : window.person;

    Object.assign(person, getServiceIdFromUrl());

    $.fn.serializeObject = function(){
        var serializedArray = this.serializeArray()
        return serializedArray.reduce((result, input) => {
            return {...result, [input.name]: input.value}
        }, {})
    }

    window.notify = new AWN({
        position: 'top-right',
        durations: {
            global: 3000
        },
        icons: {
            confirm: false,
        },
        labels: {
            'tip': 'Подсказка',
            'info': 'Информация',
            'success': 'Успешно',
            'warning': 'Предупреждение',
            'alert': 'Ошибка',
            'async': 'Подождите...',
            'confirm': 'Требуется подтверждение',
            'confirmCancel': 'Отмена'
        },
        messages: {

        }
    });

    if(window.location.host.includes('localhost')){
        window.api = axios.create({
            baseURL: 'https://27.firedemo.ru/backend/api',
            timeout: 30000,
            headers: {
                'usertoken': localStorage.getItem('usertoken'),
            },
        })
    }else{
        window.api = axios.create({
            baseURL: '/backend/api',
            timeout: 30000,
        })
    }

    axios.defaults.paramsSerializer = function(params) {};
    api.interceptors.request.use(
        function (config) {
            // if (config.url[config.url.length-1] !== '/') {
            //     config.url += '/';
            // }
            return config;
        },
        function (reject) {
            console.log('Axios reject on request', reject)
        }
    )
    let is4005 = false
    api.interceptors.response.use(
        function (response) {
            if (response.data.result === false) {
                if(!is4005)
                    notify.alert(response.data.error_message)
                console.log('resp', response)
                if (response.data.error === 4005 || response.data.error === 4004) {
                    is4005 = true
                    setTimeout(function () {
                        window.location.href = "/personal/"
                    }, notify.options.durations.global)
                    console.log('leave')
                    cookie.remove('usertoken');
                    // cookie.remove('user_id');
                    // cookie.remove('user_token');
                    // cookie.remove('User-Token');
                    // cookie.remove('User-Id');
                }
                // Promise.reject('123123')
            }
            return response.data
        },
        function (reject) {
            // console.log('Axios reject on response', reject.response)
        }
    )

    // window.addEventListener("error", async function (event) {
    //     alert('Произошла ошибка на стороне клиента, сейчас появится окно для создания скриншота, выберите вкладку или окно для скриншота');
    //     let screenshot = null;
    //     try {
    //         screenshot = await takeScreenshot();
    //     }catch (ex){
    //         console.log('perms denided')
    //     }
    //
    //
    //     // Создаём уникальный идентификатор для репорта
    //     const reportId = generateUniqueId();
    //
    //     sendErrorToServer({
    //         message: event.message,
    //         person: person,  // Это можно отправить в зашифрованном виде
    //         source: event.filename,
    //         line: event.lineno,
    //         col: event.colno,
    //         stack: event.error?.stack || "No stack trace",
    //         screenshot,
    //         reportId,  // передаем идентификатор
    //     });
    // });
    // window.addEventListener("unhandledrejection", async function (event) {
    //     alert('Произошла необработанная ошибка в Promise, сейчас появится окно для создания скриншота');
    //
    //     let screenshot = null;
    //     try {
    //         screenshot = await takeScreenshot();
    //     } catch (ex) {
    //         console.log('perms denied');
    //     }
    //
    //     // Создаём уникальный идентификатор для репорта
    //     const reportId = generateUniqueId();
    //
    //     sendErrorToServer({
    //         message: event.reason?.message || "Unhandled promise rejection",
    //         person: person,  // Это можно отправить в зашифрованном виде
    //         source: "Unknown",
    //         line: 0,
    //         col: 0,
    //         stack: event.reason?.stack || "No stack trace",
    //         screenshot,
    //         reportId,  // передаем идентификатор
    //     });
    // });

    window.saveToLocalStorage = saveToLocalStorage
    window.replaceHistoryState = replaceHistoryState;
    window.sendCode = sendCode
    window.check_code = check_code
    window.setPassword = setPassword
    window.confirm_phone = confirm_phone
    window.microModalOnShow = microModalOnShow
    window.microModalOnClose = microModalOnClose
    window.generateRandomId = generateRandomId
    window.takeScreenshoot = takeScreenshot;
    window.loadDeposits = loadDeposits
    window.loadAppointments = loadAppointments
    window.getActiveAppointments = getActiveAppointments
    window.refreshAsideAppointments = refreshAsideAppointments;
    window.loadDebtsOld = loadDebtsOld
    window.resetStorage = resetStorage
    window.loadDebts = loadDebts
    window.loadShopConfig = loadShopConfig
    window.loadShop = loadShop

    $(function(){
        $(document).on('mousedown', '.modal__overlay, .modal__close, [data-modal-close]', function(e){
            if(e.target === e.currentTarget) {
                let modalId = $(this).closest('.modal').attr('id');
                if(modalId) {
                    MicroModal.close(modalId);
                    microModalOnClose(modalId);
                }
            }
        })

        $('body').on('click', '[data-modal-open]', function(e){
            if(e.target === e.currentTarget) {

                let modalId = $(this).data('modal-open');
                if(modalId) {
                    console.log(modalId)
                    MicroModal.show(modalId);
                    microModalOnShow(modalId);
                }
            }
        })
        $('body').on('click', '[data-view-employee]', function(){
            let $this = $(this),
                employeeId = $this.data('view-employee')
            if(employeeId)
                drawCoachModal(employeeId);
        })
    })
}

export function saveToLocalStorage(record) {
    const existingRecords = JSON.parse(localStorage.getItem('spa_records')) || []; // Получаем существующий массив
    existingRecords.push(record); // Добавляем новую запись
    localStorage.setItem('spa_records', JSON.stringify(existingRecords)); // Сохраняем обратно
}
export function replaceHistoryState(){
    const currentUrl = new URL(window.location);
    currentUrl.search = '';
    window.history.replaceState({}, '', currentUrl);
}

export async function sendCode(phone, captcha) {
    if(phone && captcha){
        return await api.post('confirm_phone', {
            'phone': phone.match(/\d/g).join(''),
            'auth_type': 'sms',
            'captcha': captcha
        });
    }
    // else{
    //     return await api.post('confirm_phone', {
    //         'phone': person.client.phone.match(/\d/g).join(''),
    //         'captcha': captcha
    //     });
    // }
}
export async function check_code(phone, code){
    let response = await api.post('confirm_phone', {
        'phone': phone.match(/\d/g).join(''),
        'confirmation_code': code
    });

    if(response && response.result && response.data.pass_token){
        return response.data.pass_token;
    }
    return false;
}
export async function setPassword(phone, password, token){
    if(phone && password && token){
        let responsePassword = await api.post('password', {
            'phone': phone.match(/\d/g).join(''),
            'password': password,
            'pass_token': token
        });
        if(responsePassword && responsePassword.result) {
            let savePassword = $('[name="save_password"]').is(':checked');
            if (savePassword) {
                localStorage.setItem('remember', true)
                localStorage.setItem('login', phone.match(/\d/g).join('').slice(1))
                localStorage.setItem('password', password)
            }
            notify.success("Пароль изменен");
            cookie.set('usertoken', responsePassword.data.user_token);
            window.location.reload();
        }
    }
}
export async function confirm_phone(new_password, new_password_2, code){
    if(new_password === new_password_2){
        let response = await api.post('confirm_phone', {
            'phone': person.client.phone.match(/\d/g).join(''),
            'confirmation_code': code
        });
        if(response && response.result && response.data && response.data.pass_token){
            let responsePassword = await api.post('password', {
                'phone': person.client.phone.match(/\d/g).join(''),
                'password': new_password,
                'pass_token': response.data.pass_token
            });
            if(responsePassword && responsePassword.result) {
                let savePassword = $('[name="save_password"]').is(':checked');
                if (savePassword) {
                    localStorage.setItem('remember', true)
                    localStorage.setItem('login', person.client.phone.match(/\d/g).join('').slice(1))
                    localStorage.setItem('password', new_password)
                }
                notify.success("Пароль изменен");
            }
        }
    }else{
        notify.alert('Пароли не совпадают');
    }
}
export function microModalOnShow(modalId){
    console.log('microModalOnShow', modalId)
}
export function microModalOnClose(modalId) {
    console.log('microModalOnClose', modalId)
    if(modalId === 'payment-failed') {
        window.location = window.location.pathname;
    }
    if(modalId === 'payment-success') {
        window.location = window.location.pathname;
    }
}
export function generateRandomId() {
    return '4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
export function generateUniqueId() {
    return 'report-' + Math.random().toString(36).substr(2, 9); // Пример генерации уникального ID
}
export function sendErrorToServer(errorData) {
    api.post('errorReport', errorData).then(r => {
        notify.success('Ваше сообщение успешно было отправлено');
    })
}
export async function takeScreenshot() {
    return await new Promise((resolve, reject) => {
        navigator.mediaDevices.getDisplayMedia({ video: true })
            .then(async stream => {
                const track = stream.getVideoTracks()[0];
                console.log('track', track.label);
                const imageCapture = new ImageCapture(track);

                // Добавляем задержку (например, 2 секунды), чтобы окно выбора экрана успело закрыться
                await new Promise(resolve => setTimeout(resolve, 2000));

                imageCapture.grabFrame().then(bitmap => {
                    const canvas = document.createElement('canvas');
                    canvas.width = bitmap.width;
                    canvas.height = bitmap.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(bitmap, 0, 0);
                    const base64 = canvas.toDataURL("image/png");

                    // Закрываем поток после захвата скриншота
                    stream.getTracks().forEach(track => track.stop());

                    resolve(base64);
                }).catch(err => {
                    // Закрываем поток в случае ошибки
                    stream.getTracks().forEach(track => track.stop());
                    reject(err);
                });
            }).catch(reject);
    });
}
export async function loadAppointments() {
    console.log('loadAppointments')
    let appointmentsRes = await api.get('appointments?statuses=["planned", "passes"]'),
        appointments = {},
        plainAppointments = [];

    if (appointmentsRes && appointmentsRes.result && appointmentsRes.data) {
        for (let appointment of appointmentsRes.data) {
            let entryDate = moment(appointment.start_date).format('YYYY-MM-DD');
            plainAppointments.push(appointment);

            appointments['all'] = appointments['all'] === undefined ? [] : appointments['all']
            appointments['all'][entryDate] = appointments['all'][entryDate] === undefined ? [appointment] : appointments['all'][entryDate].concat(appointment)

            appointments[appointment.type] = appointments[appointment.type] === undefined ? [] : appointments[appointment.type]
            appointments[appointment.type][entryDate] = appointments[appointment.type][entryDate] === undefined ? [appointment] : appointments[appointment.type][entryDate].concat(appointment)

            // appointments[appointment.type] = appointment[appointment.type] === undefined ? [] : appointment[appointment.type]
            // appointments[appointment.type][entryDate] =
            // 	(appointments[appointment.type][entryDate] === undefined
            // 		? [appointment]
            // 		: appointments[appointment.type][entryDate].concat(appointment))
            //
            // console.log(appointment.type, entryDate, appointments[appointment.type][entryDate])
        }
    }

    localStorage.scheduleQuantity = plainAppointments.length;

    return {plainAppointments: plainAppointments, appointments: appointments}
}
export async function loadDeposits() {
    console.log('loadDeposists');
    let depositsResult = await api.get('deposits');
    let deposits = [],
        depositsSummary = 0;

    if (depositsResult && depositsResult.result && depositsResult.data && depositsResult.data.length > 0) {
        deposits = depositsResult.data.filter(d => d.exists);
    }



    deposits.forEach(function(deposit){
        deposit.sort = 2;
        if(deposit.name === 'Основной') deposit.sort = 1;
        if(deposit.relatives_account) deposit.sort = 4;
    })

    deposits = deposits.sort(function(a, b){
        return a.sort - b.sort;
    })

    depositsSummary = deposits.reduce((acc, debt) => {
        return (acc + debt.balance);
    }, depositsSummary);



    return {depositsSummary: depositsSummary, deposits: deposits};
}
export function getActiveAppointments() {
    if (person.appointments) {
        let appointments = []
        if (person.appointments.all) {
            for (let [date, appointmentsObject] of Object.entries(person.appointments.all)) {
                let filtered = person.appointments.all[date].filter(appointment => {
                    return (appointment.status === 'planned' || appointment.status === 'passes') && appointment.status !== 'canceled';
                })
                appointments.push(filtered)
            }
        }
        // localStorage.scheduleQuantity = flattedAppointments.length;
        return appointments.flat();
    }
    return []
}
export async function refreshAsideAppointments(){
    await loadAppointments();
    $(window).trigger('scheduleQuantity');
}
export async function loadDebtsOld() {
    console.log('loadDebts');
    let debtsResponse = await api.get("debts"),
        debts = {},
        plainDebts = [],
        debtGroups = {},
        debtsSummary = 0;

    if (debtsResponse && debtsResponse.result && debtsResponse.data.length > 0) {
        let debtsTemp = debtsResponse.data[0].debts;
        debtsSummary = debtsTemp.reduce((acc, debt) => {
            return acc + debt.total_amount;
        }, debtsSummary);

        debtsTemp
            .slice()
            .reverse()
            .forEach((debt) => {
                let date = moment(debt.date),
                    dayMonth = date.format("DD.MM"),
                    time = date.format("HH:mm"),
                    monthString = date.locale("ru-RU").format("MMMM"),
                    debtTmp = {
                        time: time,
                        dayMonth: dayMonth,
                        title: debt.description,
                        amount: debt.total_amount,
                        id: debt.id,
                    };

                plainDebts.push(debt);

                debtGroups[debt.type_tax] = debtGroups[debt.type_tax] || [];
                debtGroups[debt.type_tax].push(debt);


                debts[monthString] =
                    debts[monthString] === undefined ? {} : debts[monthString];
                debts[monthString]["sum"] =
                    (debts[monthString]["sum"] === undefined
                        ? 0
                        : debts[monthString]["sum"]) + debt.total_amount;
                debts[monthString]["debts"] =
                    debts[monthString]["debts"] === undefined
                        ? [debtTmp]
                        : debts[monthString]["debts"].concat(debtTmp);
            });
    }
    return {debtsSummary: debtsSummary, debtGroups: debtGroups, debts: debts, plainDebts: plainDebts};
};
export function resetStorage(){
    const keys = ['membershipQuantity', 'password', 'remember', 'login', 'show_canceled_appointments', 'selectedTicket'];
    const keysToRemove = ['password', 'remember', 'login'];
    const filteredKeys = keys.filter(key => !keysToRemove.includes(key));
    filteredKeys.forEach(key => {
        localStorage.removeItem(key);
    });
}
export async function loadDebts() {
    console.log('loadDebts');
    let debtsResponse = await api.get("debts"),
        debts = {},
        plainDebts = [],
        debtGroups = {},
        debtsSummary = 0;

    // Функция для обработки долгов
    const processDebts = (debtsTemp, relativeInfo = null) => {
        debtsSummary = debtsTemp.reduce((acc, debt) => {
            return acc + debt.payable_amount;
        }, debtsSummary);

        debtsTemp
            .slice()
            .reverse()
            .forEach((debt) => {
                let date = moment(debt.date),
                    dayMonth = date.format("DD.MM"),
                    time = date.format("HH:mm"),
                    monthString = date.locale("ru-RU").format("MMMM"),
                    debtTmp = {
                        time: time,
                        dayMonth: dayMonth,
                        title: debt.description,
                        amount: debt.payable_amount,
                        id: debt.id,
                        relationship: relativeInfo ? relativeInfo.relationship : null,
                        owner: relativeInfo ? relativeInfo.name.split(' ')[1] : null
                    };

                plainDebts.push(debtTmp);

                // Группировка по tax (типу налога)
                debtGroups[debt.type_tax] = debtGroups[debt.type_tax] || {};

                // Группировка по relationship внутри tax
                const relationshipKey = relativeInfo ? relativeInfo.relationship : 'self';
                debtGroups[debt.type_tax][relationshipKey] = debtGroups[debt.type_tax][relationshipKey] || {
                    relationship: relationshipKey,
                    name: relativeInfo ? relativeInfo.name : 'Вы',
                    debts: []
                };

                debtGroups[debt.type_tax][relationshipKey].debts.push(debtTmp);

                // Группировка по месяцам
                debts[monthString] = debts[monthString] || { sum: 0, debts: [] };
                debts[monthString].sum += debt.payable_amount;
                debts[monthString].debts.push(debtTmp);
            });
    };

    if (debtsResponse && debtsResponse.result && debtsResponse.data.length > 0) {
        processDebts(debtsResponse.data[0].debts);
    }

    // Проверка на необходимость загрузки долгов родственников
    if (localStorage.getItem('show_relatives_debts') === 'true' && person.relatives.length > 0) {

        for (let relative of person.relatives) {
            console.log('debts for relative', relative);
            if (relative.user_token && relative.relationship !== null) {
                let relativeDebtsResponse = await api.get("debts", {
                    headers: {
                        'usertoken': relative.user_token,
                        'x-usertoken': relative.user_token,
                        'X-UTOKEN': relative.user_token
                    }
                });

                if (relativeDebtsResponse && relativeDebtsResponse.result && relativeDebtsResponse.data.length > 0) {
                    processDebts(relativeDebtsResponse.data[0].debts, {
                        relationship: relative.relationship,
                        name: relative.name
                    });
                }
            }
        }
    }

    return { debtsSummary: debtsSummary, debtGroups: debtGroups, debts: debts, plainDebts: plainDebts };
};
export async function loadShopConfig() {
    let response = await api.get('getShopConfigJson');
    return {shopConfig: response.data ?? {}}
}
export async function loadShop() {
    console.log('loadShop');
    // let shop = await api.get('price_list'),
    let shop = await api.get('getCachedShopJson'),
        productsCount = 0,
        allProducts = [],
        products = {};


    if (shop?.length) {
        for (let product of shop) {
            let section;
            if(person?.shopConfig?.hasOwnProperty(product?.category?.id)) {
                section = person.shopConfig[product?.category?.id];
            }else{
                section = 'Другое';
            }

            allProducts.push(product);
            if(product.type === 'package' || product.type === 'online_certificate')
                products[section] = products[section] === undefined ? [product] : products[section].concat(product);
        }
        productsCount = shop.length;
    }
    return {productsCount: productsCount, products: products, allProducts: allProducts};
}





